import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Home } from 'lucide-react';
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-white py-16 px-4" data-id="element-189">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-190">
        <div className="flex items-center justify-center mb-6" data-id="element-191">
          <Home className="w-12 h-12 text-slate-700" data-id="element-192" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 text-center mb-6" data-id="element-193">
          Do you feel like a{' '}
          <span className="text-orange-500" data-id="element-194">prisoner in your own home?</span>
        </h2>
        <p className="text-lg md:text-xl text-slate-700 leading-relaxed text-center" data-id="element-195">
          Every time you pick up your keys, you see that look in your dog's
          eyes. The trembling. The whining. You know that as soon as you close
          that door, the nightmare begins for both of you.
        </p>
      </motion.div>
    </section>;
}